import { PropTypes } from 'prop-types'
import { Translate } from 'react-redux-i18n'
import { DEFAULT_LANGUAGE } from '../../../../../../../../configs/language'
import { Element } from '../../../../../../../common/html/element'
import { Tooltip } from '../../../../../../../common/tooltip'
import { valToPercent } from '../../../../../../../helpers/value'
import classes from './index.module.scss'

const renderTooltipDiscount = (item, locale) => (
  <CustomRenderToolTip item={item} locale={locale} />
)

const StackColorBarYAxis = ({
  yAxisMap,
  yAxisId,
  ranges: { data },
  barWidth = 16,
  locale = DEFAULT_LANGUAGE,
}) => {
  const yAxis = yAxisMap[yAxisId]
  if (!yAxis) return null

  const { x, y, scale, width, height } = yAxis
  const breakValues =
    data && data.length ? data.map((item) => item.scoreRange_Min) : []
  const breakCoordinateY = [y, ...breakValues.map(scale), y + height]

  return data.map((item, index) => (
    <g key={item.riskGradeTypeCode}>
      <foreignObject
        x={x + width - barWidth}
        y={breakCoordinateY[index]}
        width={barWidth}
        height={breakCoordinateY[index + 1] - breakCoordinateY[index]}
      >
        <div
          style={{
            backgroundColor: item.scoreRangeCode,
            height: '100%',
            width: '100%',
          }}
        >
          <Tooltip
            tooltipContent={renderTooltipDiscount(item, locale)}
            tooltipSpace={-10}
            contentStyle={{ height: '100%', width: '100%' }}
            tooltipStyle={{
              maxWidth: 300,
              textAlign: 'center',
            }}
            isHiddenInsideContent
          >
            <></>
          </Tooltip>
        </div>
      </foreignObject>
    </g>
  ))
}

StackColorBarYAxis.propTypes = {
  yAxisId: PropTypes.string.isRequired,
  ranges: PropTypes.shape({
    data: PropTypes.array.isRequired,
  }).isRequired,
  barWidth: PropTypes.number,
  // All rechart customized component props
}

export default StackColorBarYAxis

const CustomRenderToolTip = ({ item, locale }) => {
  return (
    <>
      <Element
        elementName="p"
        style={{
          fontWeight: 600,
          paddingBottom: 6,
          borderBottom: '1px solid #3F4145',
        }}
      >
        {item.riskGradeTypeCode}
      </Element>
      <table className={` ${classes.table} w100`}>
        <tbody>
          <tr>
            <td>
              <Translate value="riskScaleAndInterpretation.riskScore" />
            </td>
            <td>{`${item.scoreRange_Min} - ${item.scoreRange_Max}`}</td>
          </tr>
          <tr>
            <td>
              <Translate value="riskScaleAndInterpretation.riskCategory" />
            </td>
            <td>{item.scoreRangeName}</td>
          </tr>
          <tr>
            <td>
              <Translate value="riskScaleAndInterpretation.probabilityOfDefault" />
            </td>
            <td>{valToPercent(item.pd, locale, false, true)}</td>
          </tr>
        </tbody>
      </table>
    </>
  )
}
